const formTypes = {
  UPDATE_NOTIFY : "UPDATE_NOTIFY",
  UPDATE_CLAIMID : "UPDATE_CLAIMID",
  
  CLEAR_NOTIFY : "CLEAR_NOTIFY",
  GET_NOTIFY : "GET_NOTIFY",
  UPDATE_LICENSE : "UPDATE_LICENSE",
  UPDATE_CONTACT : "UPDATE_CONTACT",
  UPDATE_CONTACT_TEMPORARY : "UPDATE_CONTACT_TEMPORARY",
  UPDATE_CLAIM_TYPE : "UPDATE_CLAIM_TYPE",
  
  UPDATE_REQUEST_DOCUMENTS : "UPDATE_REQUEST_DOCUMENTS",
  
  UPDATE_DOC_TYPE_1 : "UPDATE_DOC_TYPE_1",
  UPDATE_DOC_TYPE_2 : "UPDATE_DOC_TYPE_2",
  UPDATE_DOC_TYPE_3 : "UPDATE_DOC_TYPE_3",
  UPDATE_DOC_TYPE_4 : "UPDATE_DOC_TYPE_4",
  UPDATE_DOC_TYPE_5 : "UPDATE_DOC_TYPE_5",
  UPDATE_DOC_TYPE_6 : "UPDATE_DOC_TYPE_6",
  UPDATE_DOC_TYPE_7 : "UPDATE_DOC_TYPE_7",
  UPDATE_DOC_TYPE_8 : "UPDATE_DOC_TYPE_8",
  UPDATE_DOC_TYPE_9 : "UPDATE_DOC_TYPE_9",
  UPDATE_DOC_TYPE_10 : "UPDATE_DOC_TYPE_10",
  UPDATE_DOC_TYPE_11 : "UPDATE_DOC_TYPE_11",
  UPDATE_DOC_TYPE_12 : "UPDATE_DOC_TYPE_12",
  UPDATE_DOC_TYPE_13 : "UPDATE_DOC_TYPE_13",
  UPDATE_DOC_TYPE_14 : "UPDATE_DOC_TYPE_14",
  UPDATE_DOC_TYPE_15 : "UPDATE_DOC_TYPE_15",
  UPDATE_DOC_TYPE_16 : "UPDATE_DOC_TYPE_16",
  UPDATE_DOC_TYPE_17 : "UPDATE_DOC_TYPE_17",
  UPDATE_DOC_TYPE_18 : "UPDATE_DOC_TYPE_18",
  UPDATE_DOC_TYPE_19 : "UPDATE_DOC_TYPE_19",
  UPDATE_DOC_TYPE_20 : "UPDATE_DOC_TYPE_20",
  UPDATE_DOC_TYPE_21 : "UPDATE_DOC_TYPE_21",

  DELETE_DOC_TYPE_1 : "DELETE_DOC_TYPE_1",
  DELETE_DOC_TYPE_2 : "DELETE_DOC_TYPE_2",
  DELETE_DOC_TYPE_3 : "DELETE_DOC_TYPE_3",
  DELETE_DOC_TYPE_4 : "DELETE_DOC_TYPE_4",
  DELETE_DOC_TYPE_5 : "DELETE_DOC_TYPE_5",
  DELETE_DOC_TYPE_6 : "DELETE_DOC_TYPE_6",
  DELETE_DOC_TYPE_7 : "DELETE_DOC_TYPE_7",
  DELETE_DOC_TYPE_8 : "DELETE_DOC_TYPE_8",
  DELETE_DOC_TYPE_9 : "DELETE_DOC_TYPE_9",
  DELETE_DOC_TYPE_10 : "DELETE_DOC_TYPE_10",
  DELETE_DOC_TYPE_11 : "DELETE_DOC_TYPE_11",
  DELETE_DOC_TYPE_12 : "DELETE_DOC_TYPE_12",
  DELETE_DOC_TYPE_13 : "DELETE_DOC_TYPE_13",
  DELETE_DOC_TYPE_14 : "DELETE_DOC_TYPE_14",
  DELETE_DOC_TYPE_15 : "DELETE_DOC_TYPE_15",
  DELETE_DOC_TYPE_16 : "DELETE_DOC_TYPE_16",
  DELETE_DOC_TYPE_17 : "DELETE_DOC_TYPE_17",
  DELETE_DOC_TYPE_18 : "DELETE_DOC_TYPE_18",
  DELETE_DOC_TYPE_19 : "DELETE_DOC_TYPE_19",
  DELETE_DOC_TYPE_20 : "DELETE_DOC_TYPE_20",
  DELETE_DOC_TYPE_21 : "DELETE_DOC_TYPE_21",


  DELETE_DOC_TYPE_1_ALL : "DELETE_DOC_TYPE_1_ALL",
  DELETE_DOC_TYPE_2_ALL : "DELETE_DOC_TYPE_2_ALL",
  DELETE_DOC_TYPE_3_ALL : "DELETE_DOC_TYPE_3_ALL",
  DELETE_DOC_TYPE_4_ALL : "DELETE_DOC_TYPE_4_ALL",
  DELETE_DOC_TYPE_5_ALL : "DELETE_DOC_TYPE_5_ALL",
  DELETE_DOC_TYPE_6_ALL : "DELETE_DOC_TYPE_6_ALL",
  DELETE_DOC_TYPE_7_ALL : "DELETE_DOC_TYPE_7_ALL",
  DELETE_DOC_TYPE_8_ALL : "DELETE_DOC_TYPE_8_ALL",
  DELETE_DOC_TYPE_9_ALL : "DELETE_DOC_TYPE_9_ALL",
  DELETE_DOC_TYPE_10_ALL : "DELETE_DOC_TYPE_10_ALL",
  DELETE_DOC_TYPE_11_ALL : "DELETE_DOC_TYPE_11_ALL",
  DELETE_DOC_TYPE_12_ALL : "DELETE_DOC_TYPE_12_ALL",
  DELETE_DOC_TYPE_13_ALL : "DELETE_DOC_TYPE_13_ALL",
  DELETE_DOC_TYPE_14_ALL : "DELETE_DOC_TYPE_14_ALL",
  DELETE_DOC_TYPE_15_ALL : "DELETE_DOC_TYPE_15_ALL",
  DELETE_DOC_TYPE_16_ALL : "DELETE_DOC_TYPE_16_ALL",
  DELETE_DOC_TYPE_17_ALL : "DELETE_DOC_TYPE_17_ALL",
  DELETE_DOC_TYPE_18_ALL : "DELETE_DOC_TYPE_18_ALL",
  DELETE_DOC_TYPE_19_ALL : "DELETE_DOC_TYPE_19_ALL",
  DELETE_DOC_TYPE_20_ALL : "DELETE_DOC_TYPE_20_ALL",
  DELETE_DOC_TYPE_21_ALL : "DELETE_DOC_TYPE_21_ALL",

  DELETE_DOC_TYPE_ALL : "DELETE_DOC_TYPE_ALL",
}

export default formTypes;